<template>
  <div class="product-info-section" v-if="visible">
    <!-- 图片模式 -->
    <div v-if="displayMode === 'image'" class="image-mode">
      <img 
        :src="imageUrl" 
        :alt="imageAlt"
        class="product-image"
        @click="handleImageClick"
      />
    </div>

    <!-- 文字模式 -->
    <div v-else-if="displayMode === 'text'" class="text-mode" :style="textStyle">
      <div class="product-name" v-if="productName">{{ productName }}</div>
      <div class="price-info" v-if="showPrice">
        <span class="price-label">{{ priceLabel }}</span>
        <span class="price-value" :style="priceStyle">{{ formattedPrice }}</span>
        <span class="price-unit" v-if="priceUnit">{{ priceUnit }}</span>
      </div>
      <div class="billing-mode" v-if="billingMode">{{ billingModeText }}</div>
    </div>

    <!-- 图文混合模式 -->
    <div v-else-if="displayMode === 'mixed'" class="mixed-mode">
      <img 
        :src="imageUrl" 
        :alt="imageAlt"
        class="product-image"
      />
      <div class="text-overlay" :style="overlayStyle">
        <div class="product-name" v-if="productName">{{ productName }}</div>
        <div class="price-info" v-if="showPrice">
          <span class="price-value" :style="priceStyle">{{ formattedPrice }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductInfo',
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // 是否可见
    visible() {
      return this.config.visible !== false
    },
    
    // 显示模式：image-图片, text-文字, mixed-图文混合
    displayMode() {
      return this.config.displayMode || 'image'
    },
    
    // 图片配置
    imageUrl() {
      return this.config.image?.url || ''
    },
    imageAlt() {
      return this.config.image?.alt || '产品图片'
    },
    imageClickUrl() {
      return this.config.image?.clickUrl || ''
    },
    
    // 产品名称
    productName() {
      return this.config.product?.name || ''
    },
    
    // 价格配置
    showPrice() {
      return this.config.price?.show !== false
    },
    priceLabel() {
      return this.config.price?.label || '价格：'
    },
    priceValue() {
      return this.config.price?.value || 0
    },
    priceUnit() {
      return this.config.price?.unit || '元'
    },
    priceDecimals() {
      return this.config.price?.decimals || 2
    },
    formattedPrice() {
      const value = parseFloat(this.priceValue)
      if (isNaN(value)) return '0.00'
      return value.toFixed(this.priceDecimals)
    },
    priceStyle() {
      return {
        color: this.config.price?.color || '#E7401E',
        fontSize: this.config.price?.fontSize || '0.48rem',
        fontWeight: this.config.price?.fontWeight || 'bold'
      }
    },
    
    // 计费模式
    billingMode() {
      return this.config.billing?.mode || 'monthly'
    },
    billingModeText() {
      const modeMap = {
        'monthly': '按月计费',
        'quarterly': '按季计费',
        'yearly': '按年计费',
        'onetime': '一次性付费',
        'subscription': '连续包月'
      }
      return modeMap[this.billingMode] || '按月计费'
    },
    billingText() {
      return this.config.billing?.text || ''
    },
    
    // 文字模式样式
    textStyle() {
      return {
        backgroundColor: this.config.textStyle?.backgroundColor || '#F8F9FA',
        padding: this.config.textStyle?.padding || '0.2rem',
        borderRadius: this.config.textStyle?.borderRadius || '0.1rem',
        textAlign: this.config.textStyle?.textAlign || 'center'
      }
    },
    
    // 图文混合模式文字覆盖层样式
    overlayStyle() {
      return {
        backgroundColor: this.config.overlay?.backgroundColor || 'rgba(0, 0, 0, 0.6)',
        color: this.config.overlay?.color || '#fff',
        padding: this.config.overlay?.padding || '0.1rem 0.2rem',
        borderRadius: this.config.overlay?.borderRadius || '0.1rem'
      }
    }
  },
  methods: {
    handleImageClick() {
      if (this.imageClickUrl) {
        window.location.href = this.imageClickUrl
      }
      this.$emit('action', {
        type: 'imageClick',
        data: { imageUrl: this.imageUrl }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.product-info-section {
  width: 100%;
  padding: 0.2rem;
}

// 图片模式
.image-mode {
  .product-image {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 0.1rem;
    cursor: pointer;
  }
}

// 文字模式
.text-mode {
  .product-name {
    font-size: 0.32rem;
    font-weight: bold;
    color: #333;
    margin-bottom: 0.15rem;
  }
  
  .price-info {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 0.1rem;
    margin-bottom: 0.1rem;
    
    .price-label {
      font-size: 0.24rem;
      color: #666;
    }
    
    .price-value {
      font-weight: bold;
    }
    
    .price-unit {
      font-size: 0.24rem;
      color: #999;
    }
  }
  
  .billing-mode {
    font-size: 0.22rem;
    color: #999;
  }
}

// 图文混合模式
.mixed-mode {
  position: relative;
  
  .product-image {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 0.1rem;
  }
  
  .text-overlay {
    position: absolute;
    bottom: 0.2rem;
    left: 0.2rem;
    right: 0.2rem;
    
    .product-name {
      font-size: 0.28rem;
      font-weight: bold;
      margin-bottom: 0.05rem;
    }
    
    .price-info {
      .price-value {
        font-weight: bold;
      }
    }
  }
}
</style>
